import React from 'react';
import { motion } from 'framer-motion';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.7,
  delay,
  ease: 'easeOut'
}} className={className} data-id="element-263">
    {children}
  </motion.div>;
export const Button = ({
  children,
  onClick,
  href,
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  variant?: 'primary' | 'outline';
}) => {
  const baseStyle = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-body font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 cursor-pointer';
  const variants = {
    primary: 'bg-gradient-to-r from-pink-primary to-celeste-primary text-white',
    outline: 'border-2 border-pink-primary text-pink-deep hover:bg-pink-light'
  };
  if (href) {
    return <a href={href} onClick={onClick} className={`${baseStyle} ${variants[variant]} ${className} no-underline`} data-id="element-264">
        {children}
      </a>;
  }
  return <button onClick={() => {
    if (onClick) onClick();
    window.open('https://pagos.auradigital.fun/cart/48069934907492:1', '_blank', 'noopener,noreferrer');
  }} className={`${baseStyle} ${variants[variant]} ${className}`} data-id="element-265">
      {children}
    </button>;
};
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <section id={id} className={`py-12 md:py-20 px-4 sm:px-6 lg:px-8 overflow-hidden ${className}`} data-id="element-266">
    <div className="max-w-5xl mx-auto" data-id="element-267">{children}</div>
  </section>;
export const FloralSeparator = () => <div className="flex items-center justify-center py-4 opacity-60" data-id="element-268">
    <div className="h-px w-16 bg-pink-border" data-id="element-269"></div>
    <span className="mx-4 text-pink-primary text-xl" data-id="element-270">🌸</span>
    <div className="h-px w-16 bg-pink-border" data-id="element-271"></div>
  </div>;